define(["require", "exports", "knockout", "../utils/strings", "../models/GridColumnModel"], function (require, exports, ko, strings, GridColumnModel) {
    "use strict";
    var ExportDataSource = /** @class */ (function () {
        function ExportDataSource(options) {
            this.selected = ko.observable(false);
            this.showColumns = ko.observable(false);
            this.allColumns = ko.observableArray();
            this.availableColumns = ko.observableArray();
            this.selectedColumns = ko.observableArray();
            var self = this;
            self.dataSource = options.dataSource;
            self.structure = options.structure;
            self.title = options.title;
            var flattedColumns = [];
            for (var i = 0; i < self.structure.columns.length; i++) {
                var column = self.structure.columns[i];
                if (column.exportable) {
                    if (column.field && (!column.columns || column.columns.length === 0)) {
                        flattedColumns.push(column);
                    }
                    if (column.columns) {
                        for (var j = 0; j < column.columns.length; j++) {
                            var subColumn = column.columns[j];
                            if (subColumn.field) {
                                subColumn.parentTitle = column.title;
                                flattedColumns.push(subColumn);
                            }
                        }
                    }
                }
            }
            ko.mapping.fromJS(flattedColumns, GridColumnModel.Mapping, self.availableColumns);
            ko.mapping.fromJS(flattedColumns, GridColumnModel.Mapping, self.allColumns);
            ko.utils.arrayForEach(self.allColumns(), function (item) {
                if (!item.hidden() && item.field()) {
                    self.selectedColumns.push(item);
                }
            });
            self.id = "ID".concat(strings.S(self.title).hashCode());
        }
        return ExportDataSource;
    }());
    return ExportDataSource;
});
//# sourceMappingURL=exportDataSource.js.map


//////////////////
// WEBPACK FOOTER
// ./build/shared/exportDataSource.js
// module id = 156
// module chunks = 2